import { render } from "./CitasMedicas.vue?vue&type=template&id=1c4af21e&scoped=true"
import script from "./CitasMedicas.vue?vue&type=script&lang=js"
export * from "./CitasMedicas.vue?vue&type=script&lang=js"

import "./CitasMedicas.vue?vue&type=style&index=0&id=1c4af21e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4af21e"]])

export default __exports__